export enum TimeUnits {
    DAYS = 'day',
    WEEKS = 'week',
    MONTHS = 'month',
    YEARS = 'year',
}

export const MAX_CONSENTS = 10;
